import Flickyity from 'flickity';

export default {
    init() {
        var galleryContainers = document.querySelectorAll('.data-card-slider-container');
        for (var i = 0; i < galleryContainers.length; i++) {
            initGalleryContainer(galleryContainers[i]);
        }

        function initGalleryContainer(container) {
            const slider = container.querySelector('[data-card-slider]');

            const flickity = new Flickyity(slider, {
                cellAlign: 'right',
                prevNextButtons: false,
                pageDots: false,
                imagesLoaded: true
            });

            var previousButton = container.querySelector('.button--previous');
            previousButton.addEventListener('click', function () {
                flickity.previous();
                event.preventDefault();
            });

            var nextButton = container.querySelector('.button--next');
            nextButton.addEventListener('click', function () {
                flickity.next();
                event.preventDefault();
            });
        }
    }
};
